import { useSearchParams } from 'react-router-dom';
import { articles, getArticlesByTag } from '@/mocks/articles';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import Breadcrumb from '@/components/feature/Breadcrumb';
import ScrollToTop from '@/components/base/ScrollToTop';
import SEOHead from '@/components/base/SEOHead';
import ArticleCard from './components/ArticleCard';

const tags = [
  { value: '', label: '全部' },
  { value: 'feeding', label: '喂养指南' },
  { value: 'health', label: '宝宝健康' },
  { value: 'development', label: '成长发育' },
  { value: 'mom-care', label: '妈妈护理' },
];

export default function ArticlesPage() {
  const [searchParams] = useSearchParams();
  const activeTag = searchParams.get('tag') || '';
  const filteredArticles = getArticlesByTag(activeTag);

  const seoTitle = '蜜芽育儿文章｜科学育儿知识精选';
  const seoDesc = '蜜芽育儿知识专栏，汇聚儿科医生、营养师、育儿专家专业内容，涵盖喂养指南、宝宝健康、成长发育、妈妈护理等实用育儿知识。';
  const seoKeywords = '育儿知识,宝宝喂养,母婴护理,育儿文章,蜜芽育儿';
  const canonicalUrl = 'https://childcart.github.io/articles';

  return (
    <>
      <SEOHead
        title={seoTitle}
        description={seoDesc}
        keywords={seoKeywords}
        canonicalUrl={canonicalUrl}
        schema={{
          '@context': 'https://schema.org',
          '@type': 'CollectionPage',
          name: seoTitle,
          description: seoDesc,
          url: canonicalUrl,
          isPartOf: { '@type': 'WebSite', name: '蜜芽', url: 'https://childcart.github.io' },
        }}
      />
      <ScrollToTop />
      <Navbar />

      <main className="min-h-screen pt-16">
        <div className="bg-background-50 border-b border-background-200">
          <div className="max-w-7xl mx-auto">
            <Breadcrumb
              items={[
                { label: '首页', href: '/' },
                { label: '育儿文章' },
              ]}
            />
            <div className="px-4 md:px-6 pb-6">
              <h1 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-2" style={{ fontFamily: "var(--font-heading)" }}>
                育儿知识精选
              </h1>
              <p className="text-sm text-foreground-600">科学育儿，从这里开始</p>
            </div>
          </div>
        </div>

        <div className="max-w-7xl mx-auto px-4 md:px-6 py-8">
          <div className="flex items-center gap-2 mb-8 overflow-x-auto pb-2 flex-wrap">
            {tags.map((tag) => (
              <a
                key={tag.value}
                href={tag.value ? `/articles?tag=${tag.value}` : '/articles'}
                className={`px-4 py-2 rounded-full text-sm font-medium transition-all duration-200 cursor-pointer whitespace-nowrap ${
                  activeTag === tag.value
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-100 text-foreground-700 hover:bg-background-200'
                }`}
              >
                {tag.label}
              </a>
            ))}
          </div>

          {filteredArticles.length === 0 ? (
            <div className="text-center py-20">
              <div className="w-16 h-16 mx-auto mb-4 flex items-center justify-center rounded-full bg-background-200">
                <i className="ri-article-line text-2xl text-foreground-400"></i>
              </div>
              <p className="text-foreground-500 text-sm">暂无相关文章</p>
            </div>
          ) : (
            <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 md:gap-6">
              {filteredArticles.map((article) => (
                <ArticleCard key={article.slug} article={article} />
              ))}
            </div>
          )}
        </div>
      </main>

      <Footer />
    </>
  );
}